/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Price_NotesInputs */

const cs_form_price_notes = /** @type {(inputs: Form_Price_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámky k ceně`)
};

const en_form_price_notes = /** @type {(inputs: Form_Price_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price notes`)
};

/**
* | output |
* | --- |
* | "Price notes" |
*
* @param {Form_Price_NotesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_price_notes = /** @type {((inputs?: Form_Price_NotesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Price_NotesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_price_notes(inputs)
	return cs_form_price_notes(inputs)
});